export default "__VITE_ASSET__0gLaF$jQ__"